import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'components/LazyLoad/LazyLoad';
import styles from './JobsBoardBannerAd.module.scss';
import config from '../../../config';
import {
  JOBS_BOARD_DESKTOP_CREATIVE,
  JOBS_BOARD_MOBILE_CREATIVE,
} from './creativeSizes';

const getImage = (image = '') => {
  return `${config.partnerImages}/${image}`;
};

const CreativeFrame = ({ variant, size, image, alt }) => (
  <div
    className={variant === 'desktop' ? styles.desktopFrame : styles.mobileFrame}
    data-testid={`jobs-board-ad-${variant}`}
    data-aspect-ratio={`${size.width} / ${size.height}`}
  >
    {image ? (
      <LazyLoad className={styles.lazyFill} height="100%" width="100%">
        <img
          className={styles.image}
          src={getImage(image)}
          alt={alt}
          width={size.width}
          height={size.height}
        />
      </LazyLoad>
    ) : null}
  </div>
);

CreativeFrame.propTypes = {
  variant: PropTypes.oneOf(['desktop', 'mobile']).isRequired,
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
  image: PropTypes.string,
  alt: PropTypes.string,
};

const JobsBoardBannerAd = ({ advert = null }) => {
  const frames = (
    <>
      <CreativeFrame
        variant="desktop"
        size={JOBS_BOARD_DESKTOP_CREATIVE}
        image={advert ? advert.desktop_image : ''}
        alt={advert ? advert.partner_name : ''}
      />
      <CreativeFrame
        variant="mobile"
        size={JOBS_BOARD_MOBILE_CREATIVE}
        image={advert ? advert.mobile_image : ''}
        alt={advert ? advert.partner_name : ''}
      />
    </>
  );

  return (
    <div className={styles.container} data-testid="jobs-board-ad-slot">
      {advert ? (
        <a href={advert.link_destination} target="_blank" rel="noreferrer">
          {frames}
        </a>
      ) : (
        frames
      )}
    </div>
  );
};

JobsBoardBannerAd.propTypes = {
  advert: PropTypes.object,
};

export default JobsBoardBannerAd;
